import type { ContractSectionDef } from "./types";

/**
 * Section + step layout for the Allgemein (generic) contract form — aligned
 * with the master five-section structure used by KFZ / Immobilie.
 *
 *  1. Allgemeine Informationen
 *     1.1 Kontakt / Versicherungsnehmer
 *     1.2 Allgemeine Informationen (Vorvertrag · Vertragsart · Versicherer · Produkt)
 *  2. Risikoinformationen
 *     2.1 Risikoinformationen (Betriebsanschrift + Risiko-Auswahl)
 *  3. Versicherungsumfang (Summenberechnung + Umfang zusammengefasst)
 *     3.1 Versicherungssumme
 *     3.2 Versicherungsumfang (Selbstbeteiligung)
 *  4. Vertragsdaten und Zahlung
 *     4.1 Vertragsdaten & Zahlung
 *     4.2 Zusammenfassung
 */
export const ALLGEMEIN_CONTRACT_SECTIONS: ContractSectionDef[] = [
  {
    key: "allgemein",
    title: "Allgemeine Informationen",
    color: "purple",
    steps: [
      {
        kind: "kontakt",
        key: "kontakt",
        title: "Kontakt / Versicherungsnehmer",
        description:
          "Für welchen Kontakt soll der Vertrag angelegt werden? Die Risiken werden im nächsten Abschnitt aus den Risiken dieses Kontakts ausgewählt.",
      },
      {
        kind: "vertragsBasis",
        key: "allgemeineInfo",
        title: "Allgemeine Informationen",
        description:
          "Vorvertrag, Vertragsart, Versicherer und — bei Einzelvertrag — das gewählte Produkt (Tarifierung).",
      },
    ],
  },
  {
    key: "risiken",
    title: "Risikoinformationen",
    color: "orange",
    steps: [
      {
        kind: "risikoinformation",
        key: "risikoinformation",
        title: "Risikoinformationen",
        description:
          "Betriebsanschrift aus dem Kontakt und Auswahl des zu versichernden Risikos.",
      },
    ],
  },
  {
    key: "umfang",
    title: "Versicherungsumfang",
    color: "green",
    steps: [
      {
        kind: "summen",
        key: "summen",
        title: "Versicherungssumme",
        description: "Die für diesen Vertrag versicherte Summe.",
      },
      {
        kind: "umfang",
        key: "umfang",
        title: "Versicherungsumfang",
        description:
          "Vereinbarte Selbstbeteiligung — der Anteil, den der Versicherungsnehmer im Schadenfall selbst trägt.",
      },
    ],
  },
  {
    key: "beitraege",
    title: "Vertragsdaten und Zahlung",
    color: "pillarOrange",
    steps: [
      {
        kind: "zahlung",
        key: "zahlung",
        title: "Vertragsdaten & Zahlung",
        description:
          "Vertragsnummer, Versicherungsnummer, Zweig, Risikoort, Zahlweise und Bemerkungen.",
      },
      {
        kind: "summary",
        key: "summary",
        title: "Zusammenfassung",
        description: "Überblick aller erfassten Angaben vor dem Anlegen.",
      },
    ],
  },
];
